import React from "react";
import TaskRunner from "../../components/TaskRunner/TaskRunner";
import {
  generateTasks,
  renderTask,
  renderInput,
  renderAnswer,
  renderExplanation,
  checkAnswer
} from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna";

export default function Lesson2_Tasks({ hideUtilityFabs = false } = {}) {
  return (
    <TaskRunner
      sectionTitle="Zadania: Równanie okręgu – postać kanoniczna"
      generateTasks={generateTasks}
      renderTask={renderTask}
      renderInput={renderInput}
      renderAnswer={renderAnswer}
      renderExplanation={renderExplanation}
      checkAnswer={checkAnswer}
      hideUtilityFabs={hideUtilityFabs}
    />
  );
}
